import {RadioOption} from "@valg-shared/components/input/radio/radio-option";

export type InputTypes =
  | "color"
  | "email"
  | "number"
  | "password"
  | "search"
  | "tel"
  | "text"
  | "time"
  | "file"

export interface ValgOptionInput<T> {
    label: string;
    value?: T;
    disabled?: boolean;
    isSelectAll?: boolean;
    isOtherOption?: boolean;
    isEmptyOption?: boolean;
    isAlwaysOn?: OptionPostition;
}

export enum OptionPostition {
  Top = "top",
  Bottom = "bottom"
}

export const YesNoOptions: RadioOption[] = [
    {
        value: true,
        label: 'yes',
    },
    {
        value: false,
        label: 'no',
    },
];
